import React from 'react';
import Header from '../../component/header';

const BulkSlipPrintApp = () => {
    return (
        <div style={{ width: '100vw', height: '100vh', margin: 0, padding: 0, overflow: 'hidden' }}>
            <Header title="Bulk Slip Print"/>
            <iframe
                src="https://rajkot.bjpwings.com/bulk_slip" 
                title="Bulk Slip Web View"
                style={{ width: '100%', height: '100%', border: 'none' }}
            />
        </div>
    );
};

export default BulkSlipPrintApp;